import { render, staticRenderFns } from "./DefEmail.vue?vue&type=template&id=82a4454a&scoped=true&"
import script from "./DefEmail.vue?vue&type=script&lang=js&"
export * from "./DefEmail.vue?vue&type=script&lang=js&"
import style0 from "./DefEmail.vue?vue&type=style&index=0&id=82a4454a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a4454a",
  null
  
)

export default component.exports